"use strict";

modulum("SquillaSessionEndWidget", ["SessionEndWidget", "WidgetFactory"], function (context, cls) {
  cls.SquillaSessionEndWidget = context.oo.Class(cls.SessionEndWidget, function ($super) {
    return {
      __name: "SquillaSessionEndWidget",
      __templateName: "SquillaSessionEndWidget",
      _squillaCloseTimer: null,

      // Keep the original SessionEnd contract: session links, sanitized messages
      // and restart are still supplied by VMSession, including appId/parameters.
      setHeader: function (header) {
        this._element.querySelector(".squilla-original-title").textContent = header;
        const normal = header === context.I18NService.t("gwc.app.ending.title");
        $super.setHeader.call(this, normal ? "La sesión ha finalizado" : "No se pudo abrir la transacción");
        this._element.classList.toggle("squilla-end-warning", !normal);
      },

      setMessage: function (message) {
        $super.setMessage.call(this, message);
        const detail = this._element.querySelector(".message [data-details]");
        const reason = detail ? detail.getAttribute("data-details") : "";
        const messages = {
          autoLogout: "La sesión se cerró por inactividad. Puede entrar de nuevo cuando lo necesite.",
          forbidden: "No se pudo autorizar el acceso. Compruebe sus datos antes de entrar de nuevo.",
          notok: "La sesión se interrumpió por un problema. Si continúa, comuníquese con soporte.",
          uaProxy: "Se interrumpió la comunicación con el servidor. Puede intentar entrar de nuevo."
        };
        const notice = this._element.querySelector(".squilla-end-notice");
        notice.textContent = messages[reason] || "No se pudo completar la apertura de la transacción. Consulte la información de esta sesión.";
        notice.classList.remove("hidden");
        this._element.classList.add("squilla-end-warning");
        if (reason) {
          $super.setHeader.call(this, reason === "autoLogout" ? "Sesión cerrada por inactividad" : "La sesión se interrumpió");
        }
      },

      manageMouseClick: function (domEvent) {
        if (domEvent.target && cls.DOMElementHelper.isElementOrChildOf(domEvent.target, this._closeApplicationEnd)) {
          // Do not emit the inherited 'close': it destroys the ended session and
          // redirects to the GBC homepage, losing the restart option if denied.
          this._squillaCloseWindow();
          return true;
        }
        return $super.manageMouseClick.call(this, domEvent);
      },

      _squillaCloseWindow: function () {
        if (this._squillaCloseTimer !== null) {
          window.clearTimeout(this._squillaCloseTimer);
        }
        const fallback = this._element.querySelector(".squilla-close-help");
        fallback.classList.add("hidden");
        try {
          window.close();
        } catch (error) {
          // Some embedded browsers throw; others silently refuse the request.
        }
        this._squillaCloseTimer = window.setTimeout(() => {
          this._squillaCloseTimer = null;
          if (!window.closed && this._element) {
            fallback.classList.remove("hidden");
            fallback.focus();
          }
        }, 350);
      },

      destroy: function () {
        if (this._squillaCloseTimer !== null) {
          window.clearTimeout(this._squillaCloseTimer);
          this._squillaCloseTimer = null;
        }
        $super.destroy.call(this);
      }
    };
  });
  cls.WidgetFactory.registerBuilder("SessionEnd", cls.SquillaSessionEndWidget);
});
